import { render, staticRenderFns } from "./PerguntasPizza.vue?vue&type=template&id=bf306f46&scoped=true&"
import script from "./PerguntasPizza.vue?vue&type=script&lang=js&"
export * from "./PerguntasPizza.vue?vue&type=script&lang=js&"
import style0 from "./PerguntasPizza.vue?vue&type=style&index=0&id=bf306f46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf306f46",
  null
  
)

export default component.exports